import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import DropDown      from 'dropdown';
import ContentsTab   from 'contents_tab';
import CastingCommon from '@utils/casting-common';

import SummaryMainScore  from './parts/main-score';

import ReportSummary   from '@project/contents/report/contents/summary';
import ReportList      from '@project/contents/report/contents/list';
import ReportProfiling from '@project/contents/report/contents/profiling';
// -------------------------------------------------------

class Report extends React.Component {
  render() {
    let data = this.props.data;
    
    // 通知件数の取得
    let members_count = 0;
    for( let insta_user_id in data.workflow.influencers ){
      if( CastingCommon.getReportSelectTarget(data, insta_user_id) == true ) members_count += 1;
    }
    
    let tabs = [
      { id: 'summary',  name: '概要',             html: <ReportSummary data={data} /> },
      { id: 'list',     name: '投稿一覧',         html: <ReportList data={data} /> },
      { id: 'task',     name: 'プロファイリング', html: <ReportProfiling data={data} /> },
    ];
    
    return (
      <div className="project-report">
        <div className="report-contents">
          
          <div className="summary-contents-left">
            <SummaryMainScore data={data} />
          </div>
          
          <div className="report-container">
            <ContentsTab tabs={tabs} font_size={14} />
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Report;